import * as React from 'react';
import ReactDOM from 'react-dom';
import Layout from './Layout';

ReactDOM.render(
  <Layout/>,
  document.querySelector('#root'),
);
